import { useQuery } from 'react-query';
import { apiGetJson } from '~/core/dapi';
import { getUserProfileById } from '~/core/dapi/userProfile';
import { useSolvSelector } from '~/reducers';
import { useImageUrl } from '.';
import { useQueryFamilyBookings } from '../../../hooks/useQueryFamilyBookings';
import { validateFamilyBooking } from '../../../util/validateFamilyBooking';

type Props = {
  bookingId: string;
};

export const usePhotoIdImageUrls = ({ bookingId }: Props) => {
  const { frontId, backId, frontImgUrl, backImgUrl } = useSolvSelector(
    (state) => state.paperworkMeta.photoId
  );

  const booking = useSolvSelector((state) => state.pastBookings?.[bookingId]);
  const { familyId } = validateFamilyBooking(booking);
  const { primaryBooking } = useQueryFamilyBookings(familyId);
  const userProfileId = primaryBooking?.userProfileId;
  const { data: userProfile, isLoading: isLoadingUserProfile } = useQuery(
    ['get-user-profile', userProfileId],
    async () => {
      if (frontId || !userProfileId) {
        return undefined;
      }
      const profile = await apiGetJson<any>(getUserProfileById(userProfileId));
      return profile;
    }
  );

  const photoIdFrontId = frontId ?? userProfile?.data?.photo_id_front_id;
  const { data: photoIdFrontUrl, isLoading: isLoadingFrontUrl } = useImageUrl({
    queryKey: 'get-id-front',
    photoId: photoIdFrontId,
    imgUrl: frontImgUrl,
  });

  const photoIdBackId = backId ?? userProfile?.data?.photo_id_back_id;

  const { data: photoIdBackUrl, isLoading: isLoadingBackUrl } = useImageUrl({
    queryKey: 'get-id-back',
    photoId: photoIdBackId,
    imgUrl: backImgUrl,
  });

  return {
    photoIdFrontId,
    photoIdBackId,
    photoIdFrontUrl,
    photoIdBackUrl,
    isLoadingImages: isLoadingFrontUrl || isLoadingBackUrl || isLoadingUserProfile,
  };
};
